import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class GuestIdentityImageAdapter extends ApplicationV1Adapter {}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'guest-identity-image': GuestIdentityImageAdapter;
  }
}
